import { render } from "./FadeTransition.vue?vue&type=template&id=3444a327&ts=true"
import script from "./FadeTransition.vue?vue&type=script&lang=ts"
export * from "./FadeTransition.vue?vue&type=script&lang=ts"

import "./FadeTransition.vue?vue&type=style&index=0&id=3444a327&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__